import React from 'react';
import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components/macro';

import Span from 'components/Tracked/Span';
import TLink from 'components/Tracked/Link';
import TA from 'components/Tracked/A';

import Alert from 'components/Alert';
import Pictorial from 'components/Pictorial';
import Column from 'components/Grid/Column';
import Section from 'components/Section';
import { VariantsStyles, FontVariants } from 'components/Typography';

import media from 'helpers/media';
import { blankLinkAttributes } from 'helpers';
import { ColorVariants, SpaceVariants } from 'theme';

export const TrackedSpanWrapper = styled.div<{ $addTopMargin?: boolean }>`
    text-align: center;
    ${({ $addTopMargin, theme }) =>
        $addTopMargin &&
        css`
            margin-top: ${theme.space.base};
        `};
`;

export const MobileSubCancelAlert = styled((props) => (
    <Alert
        align="left"
        icon="notification"
        color="darkGrey"
        background="lightGreen"
        iconColor="family"
        verticalCenter
        {...props}
    />
))`
    margin-top: ${({ theme }) => theme.space.large};
`;

export const StyledColumn = styled((props) => <Column {...props} />)`
    ${({ theme }) => media.mobile`
        margin-top: ${theme.space.large};
    `}
`;

const LinkStyles = css<{
    $color?: ColorVariants;
    $size?: FontVariants;
    $fontWeight?: number;
}>`
    color: ${({ theme, $color }) =>
        $color ? theme.colors[$color] : theme.colors.body};

    cursor: pointer;
    font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : 500)};
    text-decoration: underline;

    &:hover {
        color: ${({ theme, $color }) =>
            $color === 'error' ? theme.colors.error : theme.colors.brand};
    }

    ${({ $size }) =>
        $size
            ? VariantsStyles[$size]
            : `font-size: 0.875rem; line-height: 1.25rem;`};
`;

export const TrackedSpan = styled((props) => <Span {...props} />)`
    ${LinkStyles};
`;

export const StyledLink = styled.a.attrs(blankLinkAttributes())`
    ${LinkStyles};
`;

export const TrackedA = styled((props) => <TA {...props} />)`
    ${LinkStyles};
`;

export const StyledReactLink = styled((props) => <Link {...props} />)`
    ${LinkStyles};
`;

export const TrackedLink = styled((props) => <TLink {...props} />)`
    ${LinkStyles};
`;

export const ErrorAlert = styled((props) => <Alert icon="alert" {...props} />)`
    margin-top: ${({ theme }) => theme.space.base};
    &:not(:last-child) {
        margin-bottom: 0;
    }
`;

export const StyledPictorial = styled((props) => <Pictorial {...props} />)`
    text-align: center;
    margin-bottom: ${({ theme }) => theme.space.medium};
`;

export const CenteredDiv = styled.div<{ topMargin?: boolean }>`
    width: 100%;
    text-align: center;
    ${({ theme, topMargin }) =>
        topMargin &&
        css`
            margin-top: ${theme.space.medium};
        `}
`;

export const StyledSection = styled((props) => <Section {...props} />)`
    align-items: flex-start;
`;

export const Border = styled.div<{
    $color: ColorVariants;
    $spaceTop?: SpaceVariants;
    $spaceBottom?: SpaceVariants;
}>`
    width: 100%;
    height: 1px;
    background-color: ${({ theme, $color }) => theme.colors[$color]};

    ${({ theme, $spaceTop }) =>
        $spaceTop &&
        css`
            margin-top: ${theme.space[$spaceTop]};
        `};

    ${({ theme, $spaceBottom }) =>
        $spaceBottom &&
        css`
            margin-bottom: ${theme.space[$spaceBottom]};
        `};
`;
